import {
  collection,
  addDoc,
  doc,
  updateDoc,
  query,
  where,
} from "firebase/firestore";
import { createQuery, db } from "../providers/database";
import { JobDetailsNewCollection } from "../dataTypes/JobDetailsNewCollection";

import { collectionNames } from "./dictionary/collectionNames";
import { useQuery } from "react-query";

const jobDetailsNewCollectionRef = collection(
  db,
  collectionNames.jobDetailsNewCollection,
);

// Create a new entry for JobDetailsNewCollection
export async function createNewEntryForJobDetailsNewCollection(
  jobDetailsNew: JobDetailsNewCollection,
) {
  const newJob = await addDoc(jobDetailsNewCollectionRef, {
    ...jobDetailsNew,
  });
  return newJob.id;
}

// Update entry for JobDetailsNewCollection
export async function updateEntryForJobDetailsNewCollection(id: string, jobDetailsNew: any) {

  // Remove undefined values before updating Firestore
  const cleanData:any = Object.fromEntries(
      Object.entries(jobDetailsNew).filter(([_, v]) => v !== undefined)
  );

  try {
      const updatedJob = await updateDoc(
          doc(db, collectionNames.jobDetailsNewCollection, id),
          cleanData
      );
      return updatedJob;
  } catch (error) {
      console.error("Firestore Update Error:", error);
      throw error;
  }
}


export function useJobDetailsNewCollection(jobId: string) {
  return useQuery(
    ["JobDetailsNewCollection", { jobId }],
    createQuery(() => doc(db, collectionNames.jobDetailsNewCollection, jobId)),
    { enabled: !!jobId },
  );
}

export function getIsSubmittingJobFirstTime(jobData: any) {
  return (
    jobData?.solutionType === null ||
    jobData?.startDate === null ||
    jobData?.openings === null ||
    jobData?.applicationFlow === null ||
    jobData?.workSettings === null ||
    jobData?.workType === null ||
    jobData?.workTerm === null ||
    jobData?.hoursPerWeek === null ||
    jobData?.payRate === null ||
    jobData?.jobDescription === null
  );
}

export function useAllEmployerJobsByEmployerIdFromJobDetailsNewCollection(
  companyId: string,
) {
  return useQuery(
    ["AllEmployerJobsByEmployerIdFromJobDetailsNewCollection", { companyId }],
    createQuery(() =>
      query(
        collection(db, collectionNames.jobDetailsNewCollection),
        where("jobState", "==", "live"),
        where("companyId", "==", companyId),
      ),
    ),
    { enabled: !!companyId },
  );
}

export function useAllEmployerJobsWithCreditUsedByEmployerIdFromJobDetailsNewCollection(
  companyId: string,
) {
  return useQuery(
    [
      "AllEmployerLiveAndClosedJobsByEmployerIdFromJobDetailsNewCollection",
      { companyId },
    ],
    createQuery(() =>
      query(
        collection(db, collectionNames.jobDetailsNewCollection),
        where("companyId", "==", companyId),
      ),
    ),
    { enabled: !!companyId },
  );
}
